import { ExternalLink, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logoAsset from '@/assets/mbs-logo.webp.asset.json';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Marsh Business Solutions</h3>
            <img
              src={logoAsset.url}
              alt="Marsh Business Solutions logo"
              width={560}
              height={251}
              loading="lazy"
              decoding="async"
              className="h-12 w-auto mb-4 bg-white rounded-md p-2"
            />

            <p className="text-white/80 mb-6 max-w-md">
              Professional business consulting that leverages technology to improve 
              your bottom line and retain employees by building stronger company culture.
            </p>
            <div className="space-y-2 text-sm text-white/80">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <a href="tel:+13134449824" className="hover:text-white transition-colors">(313) 444-9824</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a href="mailto:stephen@marsh.business" className="hover:text-white transition-colors">stephen@marsh.business</a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                <span>Serving businesses nationwide</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <nav className="space-y-2">
              <Link to="/" className="block text-white/80 hover:text-white transition-colors">
                Home
              </Link>
              <Link to="/services" className="block text-white/80 hover:text-white transition-colors">
                Our Services
              </Link>
              <Link to="/about" className="block text-white/80 hover:text-white transition-colors">
                About Us
              </Link>
              <Link to="/contact" className="block text-white/80 hover:text-white transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4">Our Services</h4>
            <nav className="space-y-2 text-sm">
              <div className="text-white/80">Gamified Professional Development</div>
              <div className="text-white/80">AI Workforce Intelligence</div>
              <div className="text-white/80">AI Receptionist</div>
              <div className="text-white/80">AI Provenance & Governance</div>
              <div className="text-white/80">Healthcare Workforce Intelligence</div>
            </nav>
            
            <div className="mt-6">
              <h5 className="font-medium mb-3 text-sm">Featured Solutions</h5>
              <div className="space-y-2">
                <button 
                  onClick={() => window.open('https://ai4hr.xyz', '_blank')}
                  className="flex items-center gap-1 text-sm text-white/80 hover:text-white transition-colors"
                >
                  AI Concepts for the Workplace <ExternalLink className="h-3 w-3" />
                </button>
                <button 
                  onClick={() => window.open('https://blacklight.fun', '_blank')}
                  className="flex items-center gap-1 text-sm text-white/80 hover:text-white transition-colors"
                >
                  Gamified Team Building <ExternalLink className="h-3 w-3" />
                </button>
                <button 
                  onClick={() => window.open('https://ciyfr.io', '_blank')}
                  className="flex items-center gap-1 text-sm text-white/80 hover:text-white transition-colors"
                >
                  AI Workforce Intelligence <ExternalLink className="h-3 w-3" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex items-center justify-between">
          <p className="text-white/60 text-sm">
            &copy; {new Date().getFullYear()} Marsh Business Solutions. All rights reserved.
          </p>
          <Link to="/admin" className="text-white/60 hover:text-white text-xs transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
